import Dexie from "dexie";
import db from "../Db";

var DeleteAccessibilite = Dexie.async(function* () {
  yield db.open();
  yield db.ACCESSIBILITE.clear();
});

export default DeleteAccessibilite;
